import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { X as XIcon } from 'lucide-react';

import { Card, Heading, IconButton, Modal } from '@nutralab/ui';
import { useBrand } from '@nutralab/ui/brand';

import { classNames } from '@m1work/shared-utils';

import styles from './AuthModalLayout.module.scss';

import { InjectedModalProps } from '@/shared/types';

interface AuthModalLayoutProps extends InjectedModalProps {
    title: string;
    children: React.ReactNode;
}

/** The common frame of the auth modals: brand logo, title and close button. */
export function AuthModalLayout({ onClose, zIndex, title, children }: AuthModalLayoutProps): React.ReactElement {
    const { t } = useTranslation();
    const brand = useBrand();

    return (
        <Modal open onClose={onClose} zIndex={zIndex} title={title}>
            <Card className={styles.card}>
                <IconButton
                    className={styles.close}
                    variant="outlined"
                    color="soft"
                    aria-label={t('auth.modal.close')}
                    size="sm"
                    onClick={onClose}
                >
                    <XIcon />
                </IconButton>

                <img src={brand.logo.icon} alt={brand.name} className={classNames(styles.logo, 'mb-1')} />
                <Heading size="xl" weight="semibold" align="center">
                    {brand.name}
                </Heading>

                {children}
            </Card>
        </Modal>
    );
}
